import {
  ADVANCED_MODULES,
  CORE_MODULES,
  MOBILE_BUILDER_MODULES,
  MOBILE_SIGNATURE_MODULES,
  getModuleMeta,
  isHiddenMainFlowModule,
} from './moduleCatalog';

export const BUILDER_CORE_MODULES = CORE_MODULES;
export const BUILDER_MORE_MODULES = ADVANCED_MODULES;
export { MOBILE_BUILDER_MODULES };
export { MOBILE_SIGNATURE_MODULES };
export const getBuilderModuleMeta = getModuleMeta;
export { isHiddenMainFlowModule };

export const STORY_MODULE_ORDER = [
  'primary_media',
  'text',
  'ai_generator',
  'surprise_box',
  'then_now',
  'frame_gallery',
  'flip_card',
  'tiny_museum',
  'voice_postcard',
  'song_dedication',
  'memory_map',
  'timeline',
  'polaroid_booth',
  'guestbook',
  'keepsake_poster',
].filter((moduleType) => !isHiddenMainFlowModule(moduleType));

export const MODULE_LIMITS = {
  primary_media: 2,
  hero_media: 2,
  media_card: 2,
  text: 2,
  ai_generator: 1,
  surprise_box: 2,
  then_now: 2,
  frame_gallery: 2,
  flip_card: 2,
  tiny_museum: 2,
  voice_postcard: 2,
  song_dedication: 2,
  memory_map: 2,
  timeline: 2,
  polaroid_booth: 1,
  reaction: 1,
  guestbook: 1,
  keepsake_poster: 1,
};

export const MODULE_TIME_SECONDS = {
  primary_media: 28,
  hero_media: 18,
  media_card: 16,
  text: 35,
  ai_generator: 20,
  surprise_box: 22,
  then_now: 18,
  frame_gallery: 16,
  flip_card: 16,
  tiny_museum: 16,
  voice_postcard: 45,
  song_dedication: 35,
  memory_map: 35,
  timeline: 35,
  polaroid_booth: 12,
  reaction: 12,
  guestbook: 20,
  keepsake_poster: 24,
};

export const analyzeStory = (data) => {
  const modules = Array.isArray(data.modules) ? data.modules : [];
  const types = new Set(modules.map((module) => module.type));
  const templateKey = data.templateKey || data.presetKey || data.preset || data.template || '';
  const isNewBabyTemplate = templateKey === 'new_baby';
  const isRemembranceTemplate = templateKey === 'remembrance';
  const estimatedSeconds = modules.reduce((total, module) => total + (MODULE_TIME_SECONDS[module.type] || 18), 8);
  const issues = [];

  if (!data.ownerName && !data.openingTitle) issues.push('Add a personal name or opening title.');
  if (!types.has('primary_media') && !types.has('hero_media') && !types.has('media_card')) {
    issues.push(isRemembranceTemplate ? 'Add a Memory Archive with photos or short clips that feel true to their life.' : 'Add one strong first photo or video.');
  }
  if (!isNewBabyTemplate && !isRemembranceTemplate && !types.has('text')) issues.push('Add one personal note so the gift has a voice.');
  if (isNewBabyTemplate && !types.has('memory_map')) issues.push('Add baby milestones so this feels like a real firsts album.');
  if (isNewBabyTemplate && !types.has('timeline')) issues.push('Add a growth timeline so the family can keep updating this gift.');
  if (isRemembranceTemplate && !types.has('voice_postcard')) issues.push('Add a Voice Archive for spoken memories, blessings, or words the family may replay.');
  if (isRemembranceTemplate && !types.has('timeline')) issues.push('Add a Timeline so important memories have a gentle path.');
  if (isRemembranceTemplate && !types.has('guestbook')) issues.push('Add Family Messages so close loved ones can leave memories in the archive.');
  if (!isRemembranceTemplate && !types.has('voice_postcard') && !types.has('surprise_box') && !types.has('flip_card') && !types.has('tiny_museum')) {
    issues.push('Add one emotional peak: voice, reveal, or surprise.');
  }
  if (!types.has('keepsake_poster')) issues.push('Add a final card so the story has an ending.');
  if (!data.storyCoachAnswers?.threshold && !data.storyCoachAnswers?.peak) {
    issues.push('Answer one Story Coach prompt so the gift has a clear reason.');
  }
  if (modules.length > 12) issues.push('This story may feel long. Shorter gifts often feel more personal.');

  return {
    issues,
    momentCount: modules.length,
    estimatedMinutes: Math.max(1, Math.round(estimatedSeconds / 60)),
    readiness: Math.max(0, 5 - issues.length),
  };
};
